// Instructors.jsx
import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import UnderButtonNav from '../components/UnderButtonNav.jsx';

export default function Instructors() {
  const [instructors, setInstructors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstructors = async () => {
      try {
        // Простой запрос без токена
        const res = await fetch('/api/mastercars');

        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.message || `Ошибка ${res.status}`);
        }

        const data = await res.json();
        setInstructors(data);
      } catch (err) {
        console.error('Ошибка загрузки инструкторов:', err);
        setError(err.message || 'Не удалось загрузить данные');
      } finally {
        setLoading(false);
      }
    };

    fetchInstructors();
  }, []);

  // Функция склонения стажа
  const getYearWord = (years) => {
    const num = Number(years);
    if (isNaN(num)) return 'лет';
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return 'лет';
    if (lastDigit === 1) return 'год';
    if (lastDigit >= 2 && lastDigit <= 4) return 'года';
    return 'лет';
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1b1b1b] flex items-center justify-center text-[#dedede] text-xl">
        Загрузка инструкторов...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#1b1b1b] flex items-center justify-center text-red-500 text-xl">
        {error}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="mb-20 text-center">
            <span className="text-[11px] font-black uppercase tracking-[0.5em] text-primary">
              Инструкторы
            </span>
            <h1 className="text-5xl md:text-6xl font-black uppercase tracking-tighter mt-2">
              Наши инструкторы
            </h1>
            <p className="text-slate-400 mt-6 max-w-2xl mx-auto">
              Выберите инструктора по категориям, которые он преподаёт
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {instructors.map((inst) => {
            // Категории из данных инструктора
              // Категории могут быть в разных полях
              let categories = [];
              // Проверяем возможные варианты названия поля
              if (inst.categories && Array.isArray(inst.categories)) {
                categories = inst.categories;
              } else if (inst.category && Array.isArray(inst.category)) {
                categories = inst.category;
              } else if (inst.cat && Array.isArray(inst.cat)) {
                categories = inst.cat;
              }

              // Если ничего не нашли, показываем 'B' по умолчанию
              if (categories.length === 0) {
                categories = ['B'];
              }
              
              return (
                <div
                  key={inst.id}
                  className="relative bg-gradient-to-br from-[#f8f4ff] to-[#e8e0f0] rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] hover:shadow-[0_20px_40px_rgba(184,151,90,0.3)] transition-all duration-300 mx-auto w-full border border-[#d4c4b4]"
                  style={{
                    maxWidth: '500px',
                    aspectRatio: '1.585 / 1',
                  }}
                >
                  {/* ЗАЩИТНАЯ СЕТКА */}
                  <div className="absolute inset-0 opacity-[0.08] pointer-events-none"
                       style={{
                         backgroundImage: `
                           repeating-linear-gradient(45deg, 
                             #8b7a6a 0px, #8b7a6a 1px, 
                             transparent 1px, transparent 6px
                           )
                         `,
                         backgroundSize: '12px 12px'
                       }}>
                  </div>

                  {/* ТРИКОЛОР ПОЛОСКА */}
                  <div className="absolute top-0 left-0 w-full h-1.5 flex">
                    <div className="w-1/3 h-full bg-white"></div>
                    <div className="w-1/3 h-full bg-[#0039a6]"></div>
                    <div className="w-1/3 h-full bg-[#d52b1e]"></div>
                  </div>

                  {/* ОСНОВНОЙ КОНТЕНТ */}
                  <div className="relative z-10 p-3 sm:p-4 flex flex-col h-full">
                    {/* Верхняя часть с фото и данными */}
                    <div className="flex flex-1 min-h-0 gap-2 sm:gap-3">
                      {/* ЛЕВАЯ ЧАСТЬ - ФОТО */}
                      <div className="w-[35%] flex flex-col">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-br from-[#b89b5a]/30 to-[#8b6f4a]/30 rounded-lg blur-sm"></div>
                          <div className="relative bg-white p-0.5 sm:p-1 rounded-lg shadow-md border border-[#c0b0a0]">
                            <img
                              src={inst.photoUrl || "https://via.placeholder.com/140x180?text=Фото"}
                              alt={inst.fullName}
                              className="w-full aspect-[3/4] object-cover rounded-md"
                            />
                          </div>
                        </div>
                      </div>

                      {/* ПРАВАЯ ЧАСТЬ - ДАННЫЕ */}
                      <div className="w-[65%] flex flex-col">
                        <div className="mb-0.5 sm:mb-1">
                          <div className="text-[8px] sm:text-[10px] md:text-[12px] uppercase tracking-[0.2em] text-[#8b6f4a] font-bold leading-tight">
                            ВОДИТЕЛЬСКОЕ УДОСТОВЕРЕНИЕ
                          </div>
                        </div>

                        {/* ФИО */}
                        <div className="mb-1 sm:mb-2">
                          <div className="text-[8px] sm:text-[10px] md:text-[12px] uppercase text-[#8b6f4a]">ФАМИЛИЯ ИМЯ ОТЧЕСТВО</div>
                          <div className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-[#2d2d2d] uppercase tracking-tight break-words leading-tight">
                            {inst.fullName || 'ИВАНОВ ИВАН ИВАНОВИЧ'}
                          </div>
                        </div>

                        {/* ДАТА И МЕСТО РОЖДЕНИЯ */}
                        <div className="grid grid-cols-2 gap-x-1 sm:gap-x-2 gap-y-1 text-[7px] sm:text-[9px] md:text-[11px] mb-2 sm:mb-3">
                          <div>
                            <div className="text-[#8b6f4a]">ДАТА РОЖДЕНИЯ</div>
                            <div className="font-mono text-[8px] sm:text-[9px] md:text-[10px] text-[#4d4d4d] tracking-widest">
                              :: :: ::::::
                            </div>
                          </div>
                          <div>
                            <div className="text-[#8b6f4a]">МЕСТО РОЖДЕНИЯ</div>
                            <div className="font-mono text-[8px] sm:text-[9px] md:text-[10px] text-[#4d4d4d] tracking-widest truncate">
                              ::::::::::::
                            </div>
                          </div>
                        </div>

                        {/* СТАЖ */}
                        <div className="mt-auto">
                          <div className="bg-[#f0e8e0] rounded-lg py-1 sm:py-1.5 px-2 sm:px-3 border border-[#d4c4b4] inline-block">
                            <div className="text-[8px] sm:text-[10px] md:text-[12px] uppercase text-[#8b6f4a]">СТАЖ</div>
                            <div className="font-bold text-sm sm:text-base md:text-lg text-[#3d3d3d] leading-tight">
                              {inst.experience || '0'} {getYearWord(inst.experience)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* НИЖНЯЯ ЧАСТЬ - КАТЕГОРИИ */}
                    <div className="mt-2 sm:mt-3 pt-1 sm:pt-2 border-t border-[#d4c4b4] flex items-center justify-between">
                      <div className="text-[9px] sm:text-[10px] md:text-[12px] uppercase tracking-wider text-[#8b6f4a] font-bold">
                        КАТЕГОРИИ
                      </div>
                      <div className="flex gap-1 sm:gap-2">
                        {categories.length > 0 ? (
                          categories.slice(0, 5).map((cat) => (
                            <span
                              key={cat}
                              className="text-xl sm:text-2xl md:text-3xl font-black text-[#8b6f4a] drop-shadow-md"
                              style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.1)' }}
                            >
                              {cat}
                            </span>
                          ))
                        ) : (
                          <span className="text-sm text-[#8b6f4a]">B</span>
                        )}
                      </div>
                    </div>

                    {/* МИКРОТЕКСТ */}
                    <div className="absolute bottom-1 left-0 w-full flex justify-center opacity-20 pointer-events-none">
                      <span className="text-[3px] sm:text-[4px] uppercase tracking-[0.2em] sm:tracking-[0.3em] text-[#5d4d3d]">
                        АВТОШКОЛА АВТОЛИДЕР • ЛИЦЕНЗИЯ ГИБДД
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <BottomNav />
      <UnderButtonNav />
    </div>
  );
}